import { type FixedButton } from "@shared/schema";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

interface FixedCTAButtonProps {
  button: FixedButton;
  onClick?: () => void;
}

export function FixedCTAButton({ button, onClick }: FixedCTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    window.open('https://wa.me/919019323880', '_blank');
  };

  return (
    <div
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50"
      data-testid="button-cta-container"
    >
      <Button
        onClick={handleClick}
        size="default"
        className="relative px-5 py-3 text-sm md:text-base font-bold shadow-2xl hover-elevate active-elevate-2 border-2"
        style={{
          fontFamily: "'Permanent Marker', cursive",
          background: "hsl(var(--ganji-warm-cream))",
          color: "hsl(var(--ganji-rustic-brown))",
          borderColor: "hsl(var(--ganji-rustic-brown))",
          borderRadius: "0.5rem",
          transform: "rotate(-1deg)",
          boxShadow: "4px 4px 0 hsl(var(--ganji-rustic-brown) / 0.3)",
        }}
        aria-label={button.accessibility_label}
        data-testid="button-cta"
      >
        <span className="relative z-10 flex items-center gap-2">
          {button.text}
          <ArrowRight className="w-4 h-4" />
        </span>
        
        {/* Hand-drawn torn paper effect */}
        <svg
          className="absolute inset-0 w-full h-full pointer-events-none"
          style={{ filter: "drop-shadow(2px 2px 0 rgba(0,0,0,0.1))" }}
          aria-hidden="true"
        >
          <defs>
            <filter id="torn-edge">
              <feTurbulence
                type="fractalNoise"
                baseFrequency="0.05"
                numOctaves="3"
                result="noise"
              />
              <feDisplacementMap
                in="SourceGraphic"
                in2="noise"
                scale="3"
                xChannelSelector="R"
                yChannelSelector="G"
              />
            </filter>
          </defs>
        </svg>
      </Button>
    </div>
  );
}
